import { InjectionToken } from '@angular/core';

import { ADD_DOCUMENT, ADD_STORY, DOCUMENT, CUSTOM_DOCUMENT, COLOR_DOCUMENT, ERROR_DOCUMENT,CAMPAIGN_CONTACT } from './icons/documents';
import {
  ANGLE_LEFT_ICON,
  ANGLE_RIGHT_ICON,
  ARROW_UP,
  BACK_ARROW,
  CHEVRON_DOUBLE_LEFT_ICON,
  CHEVRON_DOUBLE_RIGHT_ICON,
  CHEVRON_DOWN_ICON,
  CHEVRON_LEFT_ICON,
  CHEVRON_RIGHT_ICON,
  CHEVRON_UP_ICON,
  DOWN_ARROW,
  DOWN_LIGHT_ARROW,
  FORWARD_ARROW,
  PAGINATION_LEFT_ICON,
  PAGINATION_RIGHT_ICON,
  REFRESH_ICON,
  RESIZE_ICON,
  RESIZE_DOUBLE_ARROW,
  ABOUT_FORWARD_ARROW,
  BACK_ARROW_ABOUT,
  ABOUT_MAP_ICON,
  MAP_MARKER_BOLD,
  OPEN_DRAWER
} from './icons/arrows';
import { BAN_ICON, BOLT_CIRCLE_ICON, BULLET, FLASH_ICON } from './icons/bolt';
import { BANK, CALENDAR_ICON, CARD_PAYMENT, CLOCK, INFO_ICON, CALENDOR_COLOR } from './icons/calendar';
import { CATEGORY } from './icons/category';
import { BAR_CLOSE, CLOSE, CLOSE_O, CLOSE_PARTICIPATION, CLOSE_X_ICON, XMarkIcon } from './icons/close';
import { CLOUD_DOWNLOAD, DOWNLOAD_ICON } from './icons/download';
import { EDIT, EDIT_OUTLINED } from './icons/edit';
import { EXPORT_ICON, GRAPH_ICON,GRAPH_ICON_BLUE } from './icons/export';
import { EXCLAMATION_BADGE, TICK_ICON,STAR_SHINE,REORDER_ICON, TICK_O, BLUE_TICK_ICON} from './icons/badges';
import { FEATHER_ICON } from './icons/feather';
import { FULLSCREEN_ICON } from './icons/fullscreen';
import {
  FILTER_ICON,
  FUNNEL_ICON,
  FUNNEL_ICON_OUTLINE,
  SORTDOWN,
  SORTDOWN_OUTLINE,
  SORTING_ICON,
  SORTUP,
} from './icons/filter';
import { GEAR_ICON } from './icons/setting';
import { GIFT, GIFT_OUTLINE } from './icons/gift';
import { CLIPBOARD_DOCUMENT_LIST, DOCUMENT_PEN, HAMBURGER_MENU, VERTICAL_ELLIPSIS, VERTICAL_ELLIPSIS_LARGE } from './icons/menu';
import { IMAGE_ICON, IMAGE_PLACEHOLDER } from './icons/images';
import { LINK_ICON } from './icons/link';
import {
  FACEBOOK,
  FACEBOOK_CIRCLE_O,
  LINKEDIN,
  LINKEDIN_CIRCLE_O,
  TWITTER,
  WEBSITE_ICON,
  INSTAGRAM,
  MAIL,
  PHONE,
  FACEBOOK_PROMOTIONAL,
  LINKEDINOP,
  CLIPBOARD,
  GOOGLELENO,
  FACEBOOKOP,
  TWITTER_CIRCLE_O,
  MAIL_CIRCLE_O,
  LINK,
  CLONING,
  CLONING_MOBILE,
  ACTIVITY_LOG_TABS,
  FACEBOOK_SHARE_BLUE,
  TWITTER_SHARE_BLUE,
  MAIL_SHARE_BLUE,
  LINKDIN_SHARE_BLUE,
  LENS_SHARE,
  EMBED_SHARE,
  LINK_SHARE,
} from './icons/social';
import { LOCATION_FINDER,LOCATION_FINDER_BLUE, MAP_MARKER, MAP_MARKER_OUTLINE,MAP_MARKER_FILLED_BLUE } from './icons/location';
import { PRINTER } from './icons/printer';
import { QR_SCAN_ICON, SCAN_ICON } from './icons/scan';
import { LONG_SEARCH, SEARCH, SEARCH_HELP } from './icons/search';
import { RECYCLE, SHARE_ICON, SHARE_ICON_OUTLINE, SHARE_BLUE } from './icons/share';
import { TRASH_ICON, TRASH_ICON_OUTLINE } from './icons/trash';
import { CAMERA, CLOUD_UPLOAD } from './icons/camera';
import { RADIO } from './icons/radio';
import { DRAG_CURSOR, DRAG_CURSOR_BLACK, GRAB_CURSOR } from './icons/grab-cursor';
import { SAVE_TICK, WARNING, WARNING_O } from './icons/popup';
import { BOOK_FILL, BOOK_ICON, STORY } from './icons/book';
import { ANNOUNCEMENT, ANNOUNCEMENT_O, BELL_ICON, COMMUNITY_ICON, ANNOUNCEMENT_R,ANNOUNCEMENT_B } from './icons/community';
import { PLAQUE, PLAQUE_O } from './icons/plaque';
import { MESSAGE_QUESTION, MESSAGE_QUESTION_O } from './icons/question';
import { PLUS_ROUNDED_ICON, ADD_USER_ICON, PLUS_ICON, MINUS_ICON, ADD_DISABLED } from './icons/add';
import { ROCKET } from './icons/rocket';
import { CITY, CITY_OUTLINE, MUSEUM, PARK, UNIVERSITY } from './icons/places';
import { COPY_ICON, QR_ICON } from './icons/copy';
import { INFO } from './icons/info';
import { FLASH } from './icons/flash';
import {
  DOC,
  PDF,
  PREVIEW_DOCUMENT,
  PREVIEW_IMAGE,
  PREVIEW_PDF,
  PREVIEW_SHEET,
  TEXT,
  XLS,
} from './icons/file-extensions-icons';
import { PREVIEW_DONOR, PREVIEW_ICON } from './icons/preview';
import { DOLLAR, DOLLAR_ICON, DOLLAR_OUTLINE, DOLLAR_OUTLINE_CIRCLE } from './icons/dollar';
import { GRID_ICON_FILLED, GRID_ICON_OUTLINE,GRID_ICON_OUTLINE_NEW,GRID_ICON_OUTLINE_NEW_ACTIVE, MAP_ICON_FILLED, MAP_ICON_OUTLINE, PROGRESS_BAR, RECEIPT_SEARCH_ICON_FILLED, RECEIPT_SEARCH_ICON_OUTLINE, SETELLITE_ICON_FILLED, SETELLITE_ICON_OUTLINE,STAR_ICON } from './icons/view';
import { INSPIRATION } from './icons/inspiration';
import { MULTIPLE_QUANTITY, MULTIPLE_QUANTITY_O, SINGLE_QUANTITY, SINGLE_QUANTITY_O } from './icons/quantity';
import { DOT_ICON, DOT_ICON_O } from './icons/dot';
import { CAUTION, CAUTIOS_GREEN, USER_CARD, USER_CARD_OUTLINE, USER_ICON, USERS_ICON } from './icons/user';
import { REOPEN_ITEM, STATUS_ICON } from './icons/status';
import { PAGES_ICON, UPLOAD_ICON, UPLOAD_ICON_UP, EYE_ICON, LOCK_ICON, PRICE_ICON, PUBLIC_ICON, HASTAG, HASHTAG_FILLED, ARCHIVE_ICON, LOCK_OUTLINE, EYE_OUTLINE } from './icons/extra';
import { HOUR_GLASS_ICON, HOUR_GLASS_ICON_OUTLINE } from './icons/hourglass';
import { CAMPAIGN_LIST_VIEW_ACTIVE_ICON, CAMPAIGN_LIST_VIEW_ICON, CAMPAIGN_OVERVIEW_BACK, CAMPAIGN_OVERVIEW_ICON, INTERACTIVE_TOUR, REGISTRATION, COMMUNITY, MEMORIAL, FUNDRAISER, SPONSORSHIP, VOLUNTEER, SPONSOR_BLACK, MEMORIAL_BLACK, FUNDRAISER_BLACK, INTERACTIVE_BLACK, REGISTRATION_BLACK, VENDOR_REGISTRATION_BLACK, COMMUNITY_SIGNUP_BLACK, VOLUNTEER_BLACK, SETUP_AI_CAMPAIGN, SETUP_CAMPAIGN_BUILDER, SETUP_CAMPAIGN_TEMPLATE } from './icons/campaign';
import { EDIT_CUSTOM_FORM, PREVIEW_CUSTOM_FORM } from './icons/in-app-form';
import { ADD_CAMPAIGN_ITEM, CAMP_AVAILABLE, CAMP_DONATED, CAMP_FUNDRAISER, CAMP_INTERACTIVE_TOUR, CAMP_MEMORIAL_PROGRAM, CAMP_NOTIFICATIONS, CAMP_OVERVIEW, CAMP_PHOTOS_DOCUMENTS, CAMP_READY_TO_COMPLETE, CAMP_REGISTRATION, CAMP_VENDOR_REGISTRATION, CAMP_COMMUNITY_SIGNUP, CAMP_RIGHT_ARROW, CAMP_SETTINGS, CAMP_SPONSORSHIP, CAMP_VOLUNTEER_ACTIVITY, CAMP_WARNING, ITE_LOW_TO_HIGH, ITEM_HIGH_TO_LOW, CAMP_READY_TO_COMPLETE_WHITE, EDIT_ROW, DELETE_ROW, NEXT_STOP, PREVIOUS_STOP, NEXT_STOP_DISABLED, PREVIOUS_STOP_DISABLED, CAMP_PHOTOS_DOCUMENTS_ERROR, CAMP_OVERVIEW_ERROR, CAMP_NOTIFICATIONS_ERROR, CAMP_SETTINGS_ERROR, CAMP_CAMPAIGN_TYPE, CAMP_FILTER_OPEN,CAMP_FILTER_BLACK, CAMP_FILTER_CLEAR, CAMP_STATUS_FILTER, CAMP_STATUS_FILTER_ACTIVE, CAMP_FILTER_OPEN_ACTIVE, CAMP_CAMPAIGN_TYPE_ACTIVE, CAMP_STATUS_ACTIVE_CHIP, CAMP_STATUS_COMPLETED_CHIP, CAMP_FILTER_OPEN_DISABLED, CAMP_CAMPAIGN_TYPE_DISABLED, CAMP_STATUS_FILTER_DISABLED, CAMP_INTERACTIVE_NEW, CAMP_INTERACTIVE_NEW_BLACK, ARCHIVE_CAMPAIGN, RESTORE_CAMPAIGN, PUBLIC_TAB, PUBLIC_TAB_ACTIVE, PRIVATE_TAB, PRIVATE_TAB_ACTIVE, ARCHIVE_TAB_ACTIVE, ARCHIVE_TAB, TWITTER_SHARE, EMAIL_SHARE, CUSTOMIZE_EMAIL_ICON,REACTIVATE_CAMPAIGN, CAMP_INTERACTIVE_ORANGE, PREVIOUS_PAGE, NEXT_PAGE, NEXT_PAGE_DISABLED, PREVIOUS_PAGE_DISABLED, DELETE_MEDIA,DELETE_CONTACT,CAMP_TICKETING, CAMP_TICKETING_BLUE, STAR, SHARE_STATUS, CAMP_AVAILABLE_ERROR, ADD_CAMPAIGN, REMOVE_CAMPAIGN, ADD_CAMPAIGN_DROPDOWN, CAMP_INTERACTIVE_INITIATIVE } from './icons/campaign-add-edit-screen';
import { ACTIVITY_LOG } from './icons/edit';
import { ACTIVITY_ACTION_BUTTON, ACTIVITY_DATE, ACTIVITY_DOC, ACTIVITY_EDIT_DRAWER, ICON_TOTAL_ACTIVITIES, POSTED_CAMPAIGNS, TOTAL_DONATIONS, TOTAL_MEMORIALS, TOTAL_REGISTRATIONS, TOTAL_SPONSORSHIPS, TOTAL_VOLUNTEER_SIGN_UPS,ACTIVITY_DELETE_ICON, ACTIVITY_VIEW_ICON, ACTIVITY_EDIT_ICON, ACTIVITY_ATTENDANCE_ICON, ACTIVITY_DELETE_ACTION_ICON,ACTIVITY_DELETE_ACTION_DISABLED_ICON, CHECK_IN_MANAGER_ICON, QR_CODE_ICON, TICKET_CHECKED_IN_ICON, TICKET_IN_USE_ICON, RETURN_ICON, SEE_MY_LEGACY, TICKET_HOLDER_ICON, CLOSE_CHECK_IN_ICON, NO_TICKET_HOLDER_ICON, QR_CODE_SCANNED, ALL_CHECKED_IN, PREVIEW_IMAGE_ICON } from './icons/activity-log';
import { AI_CHECKBOX_ICON, AI_DROPDOWN_ICON, AI_FUNDRAISER_STEP_ICON, AI_FUNDRAISING_ICON, AI_HASHTAG_ICON, AI_MEMORIAL_ICON, AI_MEMORIAL_STEP_ICON, AI_PAYMENT_APPROVAL_ICON, AI_PRICE_ICON, AI_REGISTRATION_ICON, AI_VENDOR_REGISTRATION_ICON, AI_COMMUNITY_SIGNUP_ICON, AI_REGISTRATION_STEP_ICON, AI_SPONSORSHIP_ICON, AI_SPONSORSHIP_STEP_ICON, AI_STEP_4_ICON, AI_SUGGESTED_FIELD_ICON, AI_TICKETING_ICON, AI_TICKETING_STEP_ICON, AI_VOLUNTEER_ICON, AI_VOLUNTEER_STEP_ICON, CAMPAIGN_OPTION_TEAM, CAMPAIGN_OPTION_BUILDER, CAMPAIGN_OPTION_TEMPLATE, CAMPAIGN_OPTION_CLOCK, CAMPAIGN_OPTION_BOLT } from './icons/ai-campaign-icon';
import { APPLICATION_REQUIRED, APPROVE_APPLICANT, APPROVE_CONFIRMATION_TICK, APPROVED_APPLICANTS, AWAITING_REVIEW, DOC_WARNING, NO_APPLICATION_REQUIRED, PAYMENT_ICON, REJECT_APPLICANT, REJECT_APPLICANT_DIALOG, SEEMYLEGACY_ICON, SEND_EMAIL_ICON, TOTAL_APPLICANTS } from './icons/two-part-process';
import { CIRCLE_PERCENTAGE, SMALL_TICK, SMALL_TICKET } from './icons/item';
import { CALENDAR_LINE, CHAT_BUBBLE, CHEVRON_FORWARD, HELP_CIRCLE, MAIL_LINE, PHONE_LINE } from './icons/support-panel';
import { DISBURSEMENT_EDIT, DISBURSEMENT_EXPAND, DISBURSEMENT_SUCCESS_BADGE, DISBURSEMENT_UPDATE_BADGE, PAYMENTS, SORT_ARROW_DOWN } from './icons/disbursement';
import {
  CO_ARROW_UP,
  CO_MEDAL,
  CO_SPARK_ORANGE,
  CO_SPARK_PINK,
  CO_BADGE_CHECK,
  CO_PIN_FILLED,
  CO_PIN_OUTLINE_THICK,
  CO_PIN_OUTLINE,
  CO_CHEVRON_DOWN_THICK,
  CO_CHEVRON_DOWN,
  CO_OUTLINK,
  CO_CALENDAR,
  CO_PLUS,
  CO_USER_PLUS,
  CO_DEDICATION,
  CO_MAP_ART_GRID,
  CO_CHECK,
  CO_MAP_ART_RIVER,
  CO_FOLDED_MAP,
  CO_FOLDED_MAP_SMALL,
  CO_BACK_ARROW,
  CO_DOT,
  CO_TOGGLE,
  CO_ACTIVITY_LOG,
  CO_DUPLICATE,
  CO_MOVE,
  CO_LINK,
  CO_ADDRESS_MAP,
  CO_ARROW_OUT,
  CO_CLOSE,
  CO_SEARCH,
  CO_EYE,
  CO_CHEVRON_RIGHT,
  CO_CHEVRON_LEFT,
  CO_EXPAND,
  CO_ZOOM_OUT,
  CO_ZOOM_IN,
  CO_CROSSHAIR,
} from './icons/campaign-overview';
export const Icons = new Map([
  ['add-document', ADD_DOCUMENT],
  ['add-document-o', ADD_DOCUMENT],
  ['add-story', ADD_STORY],
  ['arrow-back', BACK_ARROW],
  ['arrow-down', DOWN_ARROW],
  ['arrow-down-thin', DOWN_LIGHT_ARROW],
  ['arrow-forward', FORWARD_ARROW],
  ['arrow-up-thin', ARROW_UP],
  ['chevron-left', CHEVRON_LEFT_ICON],
  ['chevron-right', CHEVRON_RIGHT_ICON],
  ['chevron-up', CHEVRON_UP_ICON],
  ['chevron-down', CHEVRON_DOWN_ICON],
  ['chevron-double-left', CHEVRON_DOUBLE_LEFT_ICON],
  ['chevron-double-right', CHEVRON_DOUBLE_RIGHT_ICON],
  ['pagination-left', PAGINATION_LEFT_ICON],
  ['pagination-right', PAGINATION_RIGHT_ICON],
  ['angle-left', ANGLE_LEFT_ICON],
  ['angle-right', ANGLE_RIGHT_ICON],
  ['ban', BAN_ICON],
  ['bolt-circle', BOLT_CIRCLE_ICON],
  ['calendar', CALENDAR_ICON],
  ['category', CATEGORY],
  ['close', CLOSE],
  ['download', DOWNLOAD_ICON],
  ['edit', EDIT],
  ['edit-o', EDIT_OUTLINED],
  ['disbursement-edit', DISBURSEMENT_EDIT],
  ['exclamation', EXCLAMATION_BADGE],
  ['export', EXPORT_ICON],
  ['facebook', FACEBOOK],
  ['facebook-circle-o', FACEBOOK_CIRCLE_O],
  ['feather', FEATHER_ICON],
  ['fullscreen', FULLSCREEN_ICON],
  ['filter', FILTER_ICON],
  ['flash', FLASH_ICON],
  ['funnel', FUNNEL_ICON],
  ['funnel-o', FUNNEL_ICON_OUTLINE],
  ['gear', GEAR_ICON],
  ['gift', GIFT],
  ['gift-o', GIFT_OUTLINE],
  ['website', WEBSITE_ICON],
  ['graph', GRAPH_ICON],
  ['graph-blue', GRAPH_ICON_BLUE],
  ['hamburger-menu', HAMBURGER_MENU],
  ['image', IMAGE_ICON],
  ['instagram', INSTAGRAM],
  ['link', LINK_ICON],
  ['linkedin-circle-o', LINKEDIN_CIRCLE_O],
  ['linkedin', LINKEDIN],
  ['map-marker', MAP_MARKER],
  ['map-marker-blue', MAP_MARKER_FILLED_BLUE],
  ['map-marker-o', MAP_MARKER_OUTLINE],
  ['placeholder-image', IMAGE_PLACEHOLDER],
  ['printer', PRINTER],
  ['refresh', REFRESH_ICON],
  ['resize', RESIZE_ICON],
  ['scan', SCAN_ICON],
  ['scan-qr', QR_SCAN_ICON],
  ['search', SEARCH],
  ['search-help-filled', SEARCH_HELP],
  ['share', SHARE_ICON],
  ['share-o', SHARE_ICON_OUTLINE],
  ['sorting', SORTING_ICON],
  ['tick', TICK_ICON],
  ['trash', TRASH_ICON],
  ['trash-outline', TRASH_ICON_OUTLINE],
  ['twitter', TWITTER],
  ['vertical-ellipsis', VERTICAL_ELLIPSIS],
  ['camera', CAMERA],
  ['radio', RADIO],
  ['grab-cursor', GRAB_CURSOR],
  ['drag-cursor', DRAG_CURSOR],
  ['save-tick', SAVE_TICK],
  ['warning', WARNING],
  ['book', BOOK_ICON],
  ['community', COMMUNITY_ICON],
  ['plaque', PLAQUE],
  ['question', MESSAGE_QUESTION],
  ['document', DOCUMENT],
  ['radio', RADIO],
  ['grab-cursor', GRAB_CURSOR],
  ['save-tick', SAVE_TICK],
  ['warning', WARNING],
  ['book', BOOK_ICON],
  ['community', COMMUNITY_ICON],
  ['plaque', PLAQUE],
  ['question', MESSAGE_QUESTION],
  ['document', DOCUMENT],
  ['sortdown', SORTDOWN],
  ['plus', PLUS_ICON],
  ['minus', MINUS_ICON],
  ['plus-rounded', PLUS_ROUNDED_ICON],
  ['copy', COPY_ICON],
  ['qr', QR_ICON],
  ['rocket', ROCKET],
  ['location', LOCATION_FINDER],
  ['location-blue', LOCATION_FINDER_BLUE],
  ['city', CITY],
  ['park', PARK],
  ['museum', MUSEUM],
  ['university', UNIVERSITY],
  ['announcement', ANNOUNCEMENT],
  ['bell', BELL_ICON],
  ['book-o', STORY],
  ['city-o', CITY_OUTLINE],
  ['dot', BULLET],
  ['sortdown-o', SORTDOWN_OUTLINE],
  ['sortup', SORTUP],
  ['flash', FLASH],
  ['book-fill', BOOK_FILL],
  ['info', INFO],
  ['close-o', CLOSE_O],
  ['x-mark', XMarkIcon],
  ['plaque-o', PLAQUE_O],
  ['pdf', PDF],
  ['word', DOC],
  ['excel', XLS],
  ['text', TEXT],
  ['preview-pdf', PREVIEW_PDF],
  ['preview-document', PREVIEW_DOCUMENT],
  ['preview-image', PREVIEW_IMAGE],
  ['preview-sheet', PREVIEW_SHEET],
  ['add-user', ADD_USER_ICON],
  ['preview', PREVIEW_ICON],
  ['plaque-o', PLAQUE_O],
  ['pdf', PDF],
  ['word', DOC],
  ['excel', XLS],
  ['text', TEXT],
  ['tick_o', TICK_O],
  ['blue-tick',BLUE_TICK_ICON],
  ['dollar', DOLLAR],
  ['dollar-o', DOLLAR_OUTLINE],
  ['dollar-icon', DOLLAR_ICON],
  ['dollar-outline-circle',DOLLAR_OUTLINE_CIRCLE],
  ['receipt-search', RECEIPT_SEARCH_ICON_FILLED],
  ['receipt-search-o', RECEIPT_SEARCH_ICON_OUTLINE],
  ['map', MAP_ICON_FILLED],
  ['map-o', MAP_ICON_OUTLINE],
  ['grid', GRID_ICON_FILLED],
  ['grid-o', GRID_ICON_OUTLINE],
  ['inspiration', INSPIRATION],
  ['setellite-o', SETELLITE_ICON_OUTLINE],
  ['setellite', SETELLITE_ICON_FILLED],
  ['single-quantity', SINGLE_QUANTITY],
  ['single-quantity-o', SINGLE_QUANTITY_O],
  ['multiple-quantity', MULTIPLE_QUANTITY],
  ['multiple-quantity-o', MULTIPLE_QUANTITY_O],
  ['warning_o', WARNING_O],
  ['dot', DOT_ICON],
  ['dot-o', DOT_ICON_O],
  ['clipboard-document-list', CLIPBOARD_DOCUMENT_LIST],
  ['document-pen', DOCUMENT_PEN],
  ['user-icon', USER_ICON],
  ['users-icon', USERS_ICON],
  ['status-o', STATUS_ICON],
  ['pages-o', PAGES_ICON],
  ['upload-o', UPLOAD_ICON],
  ['upload-up', UPLOAD_ICON_UP],
  ['hourglass', HOUR_GLASS_ICON],
  ['hourglass', HOUR_GLASS_ICON],
  ['resize-double', RESIZE_DOUBLE_ARROW],
  ['hourglass-o', HOUR_GLASS_ICON_OUTLINE],
  ['eye', EYE_ICON],
  ['archive', ARCHIVE_ICON],
  ['lock', LOCK_ICON],
  ['hashtag', HASTAG],
  ['hashTag-o', HASHTAG_FILLED],
  ['public-eye', PUBLIC_ICON],
  ['custom-price', PRICE_ICON],
  ['announcement-o', ANNOUNCEMENT_O],
  ['question-o', MESSAGE_QUESTION_O],
  ['mail', MAIL],
  ['phone', PHONE],
  ['sponsorship', SPONSORSHIP],
  ['volunteer', VOLUNTEER],
  ['community-campaign', COMMUNITY],
  ['memorial', MEMORIAL],
  ['arrow-forward-about', ABOUT_FORWARD_ARROW],
  ['arrow-back-about', BACK_ARROW_ABOUT],
  ['user-card', USER_CARD],
  ['user-card-o', USER_CARD_OUTLINE],
  ['about-map-icon', ABOUT_MAP_ICON],
  ['campaign-overview', CAMPAIGN_OVERVIEW_ICON],
  ['campaign-overview-back', CAMPAIGN_OVERVIEW_BACK],
  ['clock', CLOCK],
  ['progress-bar', PROGRESS_BAR],
  ['facebook-promotional', FACEBOOK_PROMOTIONAL],
  ['cloud-upload', CLOUD_UPLOAD],
  ['list-view', CAMPAIGN_LIST_VIEW_ICON],
  ['list-view-o', CAMPAIGN_LIST_VIEW_ACTIVE_ICON],
  ['preview-donor', PREVIEW_DONOR],
  ['Bank', BANK],
  ['Card-Payment', CARD_PAYMENT],
  ['info-icon', INFO_ICON],
  ['custom-document', CUSTOM_DOCUMENT],
  ['lens', GOOGLELENO],
  ['cliboard', CLIPBOARD],
  ['preview-custom-form', PREVIEW_CUSTOM_FORM],
  ['edit-custom-form', EDIT_CUSTOM_FORM],
  ['camp-overview', CAMP_OVERVIEW],
  ['camp-photos-documents', CAMP_PHOTOS_DOCUMENTS],
  ['camp-notifications', CAMP_NOTIFICATIONS],
  ['camp-settings', CAMP_SETTINGS],
  ['camp-overview-error', CAMP_OVERVIEW_ERROR],
  ['camp-photos-documents-error', CAMP_PHOTOS_DOCUMENTS_ERROR],
  ['camp-notifications-error', CAMP_NOTIFICATIONS_ERROR],
  ['camp-settings-error', CAMP_SETTINGS_ERROR],
  ['camp-available', CAMP_AVAILABLE],
  ['camp-available-error', CAMP_AVAILABLE_ERROR],
  ['camp-donated', CAMP_DONATED],
  ['camp-ready-to-complete', CAMP_READY_TO_COMPLETE],
  ['camp-right-arrow', CAMP_RIGHT_ARROW],
  ['camp-warning', CAMP_WARNING],
  ['camp-sponsorship', CAMP_SPONSORSHIP],
  ['camp-fundraiser', CAMP_FUNDRAISER],
  ['camp-memorial-program', CAMP_MEMORIAL_PROGRAM],
  ['camp-registration', CAMP_REGISTRATION],
  ['camp-vendor-registration', CAMP_VENDOR_REGISTRATION],
  ['camp-community-signup', CAMP_COMMUNITY_SIGNUP],
  ['camp-volunteer-activity', CAMP_VOLUNTEER_ACTIVITY],
  ['camp-interactive-tour', CAMP_INTERACTIVE_TOUR],
  ['camp-ticketing', CAMP_TICKETING],
  ['star', STAR],
  ['camp-ticketing-blue', CAMP_TICKETING_BLUE],
  ['add-campaign-item', ADD_CAMPAIGN_ITEM],
  ['item-high-to-low', ITEM_HIGH_TO_LOW],
  ['item-low-to-high', ITE_LOW_TO_HIGH],
  ['map-marker-bold', MAP_MARKER_BOLD],
  ['linkedin-share-dropdown', LINKEDINOP],
  ['facebook-share-dropdown', FACEBOOKOP],
  ['recycle', RECYCLE],
  ['activity-log', ACTIVITY_LOG],
  ['announcement-r', ANNOUNCEMENT_R],
  ['announcement-p', ANNOUNCEMENT_R],
  ['color-document', COLOR_DOCUMENT],
  ['color-calendar', CALENDOR_COLOR],
  ['camp-ready-to-complete-white', CAMP_READY_TO_COMPLETE_WHITE],
  ['edit-row', EDIT_ROW],
  ['delete-row', DELETE_ROW],
  ['fundraiser', FUNDRAISER],
  ['fundraiser-black', FUNDRAISER_BLACK],
  ['registration', REGISTRATION],
  ['registration-black', REGISTRATION_BLACK],
  ['vendor-registration-black', VENDOR_REGISTRATION_BLACK],
  ['community-signup-black', COMMUNITY_SIGNUP_BLACK],
  ['interactive-tour', INTERACTIVE_TOUR],
  ['interactive-black', INTERACTIVE_BLACK],
  ['memorial-black', MEMORIAL_BLACK],
  ['sponsorship-black', SPONSOR_BLACK],
  ['volunteer-black', VOLUNTEER_BLACK],
  ['share-blue', SHARE_BLUE],
  ['previous-stop', PREVIOUS_STOP],
  ['next-stop', NEXT_STOP],
  ['add-disabled', ADD_DISABLED],
  ['next-stop-disabled', NEXT_STOP_DISABLED],
  ['previous-stop-disabled', PREVIOUS_STOP_DISABLED],
  ['camp-campaign-type', CAMP_CAMPAIGN_TYPE],
  ['camp-campaign-type-active', CAMP_CAMPAIGN_TYPE_ACTIVE],
  ['camp-campaign-type-disabled', CAMP_CAMPAIGN_TYPE_DISABLED],
  ['camp-filter-open', CAMP_FILTER_OPEN],
  ['camp-filter-clear', CAMP_FILTER_CLEAR],
  ['camp-status-filter', CAMP_STATUS_FILTER],
  ['camp-status-filter-active', CAMP_STATUS_FILTER_ACTIVE],
  ['camp-status-filter-disabled', CAMP_STATUS_FILTER_DISABLED],
  ['camp-filter-open-active', CAMP_FILTER_OPEN_ACTIVE],
  ['camp-filter-open-disabled', CAMP_FILTER_OPEN_DISABLED],
  ['camp-active-chip', CAMP_STATUS_ACTIVE_CHIP],
  ['camp-completed-chip', CAMP_STATUS_COMPLETED_CHIP],
  ['camp-interactive-new', CAMP_INTERACTIVE_NEW],
  ['camp-interactive-orange', CAMP_INTERACTIVE_ORANGE],
  ['camp-interactive-new-black', CAMP_INTERACTIVE_NEW_BLACK],
  ['archive-campaign', ARCHIVE_CAMPAIGN],
  ['restore-campaign', RESTORE_CAMPAIGN],
  ['public-tab', PUBLIC_TAB],
  ['public-tab-active', PUBLIC_TAB_ACTIVE],
  ['private-tab', PRIVATE_TAB],
  ['private-tab-active', PRIVATE_TAB_ACTIVE],
  ['archive-tab', ARCHIVE_TAB],
  ['archive-tab-active', ARCHIVE_TAB_ACTIVE],
  ['twitter-share',TWITTER_SHARE],
  ['email-share',EMAIL_SHARE],
  ['twitter-circle-o',TWITTER_CIRCLE_O],
  ['mail-circle-o',MAIL_CIRCLE_O],
  ['link-clip',LINK],
  ['cloning',CLONING],
  ['cloning-mobile',CLONING_MOBILE],
  ['activity-date-icon',ACTIVITY_DATE],
  ['activity-doc', ACTIVITY_DOC],
  ['activity-action-button', ACTIVITY_ACTION_BUTTON],
  ['customize-email-icon',CUSTOMIZE_EMAIL_ICON],
  ['reactivate-campaign',REACTIVATE_CAMPAIGN],
  ['close-participation',CLOSE_PARTICIPATION],
  ['delete-media',DELETE_MEDIA],
  ['activity-edit-drawer',ACTIVITY_EDIT_DRAWER],
  ['activity-log-tabs',ACTIVITY_LOG_TABS],
  ['previous-page', PREVIOUS_PAGE],
  ['next-page', NEXT_PAGE],
  ['next-page-disabled', NEXT_PAGE_DISABLED],
  ['previous-page-disabled', PREVIOUS_PAGE_DISABLED],
  ['total-activities',ICON_TOTAL_ACTIVITIES],
  ['posted-campaigns',POSTED_CAMPAIGNS],
  ['total-sponsorships',TOTAL_SPONSORSHIPS],
  ['total-memorials',TOTAL_MEMORIALS],
  ['total-donations',TOTAL_DONATIONS],
  ['total-registrations',TOTAL_REGISTRATIONS],
  ['total-vol-sign-ups',TOTAL_VOLUNTEER_SIGN_UPS],
  ['activity-log-delete',ACTIVITY_DELETE_ICON],
  ['activity-view',ACTIVITY_VIEW_ICON],
  ['activity-edit',ACTIVITY_EDIT_ICON],
  ['activity-attendance',ACTIVITY_ATTENDANCE_ICON],
  ['activity-delete-action',ACTIVITY_DELETE_ACTION_ICON],
  ['activity-delete-action-disabled',ACTIVITY_DELETE_ACTION_DISABLED_ICON],
  ['lock-o',LOCK_OUTLINE],
  ['eye-o',EYE_OUTLINE],
  ['check-in-manager-icon',CHECK_IN_MANAGER_ICON],
  ['qr-code-icon', QR_CODE_ICON],
  ['close-x-icon',CLOSE_X_ICON],
  ['cloud-download',CLOUD_DOWNLOAD],
  ['long-search',LONG_SEARCH],
  ['error-document',ERROR_DOCUMENT],
  ['ticket-checked-in',TICKET_CHECKED_IN_ICON],
  ['ticket-in-use',TICKET_IN_USE_ICON],
  ['return-icon',RETURN_ICON],
  ['see-my-legacy',SEE_MY_LEGACY],
  ['ticket-holder-icon',TICKET_HOLDER_ICON],
  ['star-shine',STAR_SHINE],
  ['reorder-icon',REORDER_ICON],
  ['star-icon',STAR_ICON],
  ['bar-close',BAR_CLOSE],
  ['caution', CAUTION],
  ['drag-cursor-black', DRAG_CURSOR_BLACK],
  ['camp-filter-black', CAMP_FILTER_BLACK],
  ['grid-o-new', GRID_ICON_OUTLINE_NEW],
  ['grid-o-new-active', GRID_ICON_OUTLINE_NEW_ACTIVE],
  ['close-check-in',CLOSE_CHECK_IN_ICON],
  ['no-ticket-holder',NO_TICKET_HOLDER_ICON],
  ['caution-green', CAUTIOS_GREEN],
  ['qr-code-scanned',QR_CODE_SCANNED],
  ['all-checked-in',ALL_CHECKED_IN],
  ['open-drawer', OPEN_DRAWER],
  ['facebook-blue-share',FACEBOOK_SHARE_BLUE],
  ['twitter-share-blue',TWITTER_SHARE_BLUE],
  ['mail-share-blue',MAIL_SHARE_BLUE],
  ['linkedin-share-blue',LINKDIN_SHARE_BLUE],
  ['lens-blue',LENS_SHARE],
  ['embed-blue',EMBED_SHARE],
  ['link-share-blue',LINK_SHARE],
  ['preview-icon',PREVIEW_IMAGE_ICON],
  ['share-status', SHARE_STATUS],
  ['vertical-ellipsis-large',VERTICAL_ELLIPSIS_LARGE],
  ['add-campaign',ADD_CAMPAIGN],
  ['remove-campaign-list',REMOVE_CAMPAIGN],
  ['add-campaign-list',ADD_CAMPAIGN_DROPDOWN],
  ['camp-interactive-initiative',CAMP_INTERACTIVE_INITIATIVE],
  ['announcement-b', ANNOUNCEMENT_B],
  ['ai-sponsorship',AI_SPONSORSHIP_ICON],
  ['ai-ticketing', AI_TICKETING_ICON],
  ['ai-registration', AI_REGISTRATION_ICON],
  ['ai-vendor-registration', AI_VENDOR_REGISTRATION_ICON],
  ['ai-community-signup', AI_COMMUNITY_SIGNUP_ICON],
  ['ai-volunteer',AI_VOLUNTEER_ICON],
  ['ai-memorial',AI_MEMORIAL_ICON],
  ['ai-fundraising',AI_FUNDRAISING_ICON],
  ['ai-payment-approval',AI_PAYMENT_APPROVAL_ICON],
  ['ai-price', AI_PRICE_ICON],
  ['ai-dropdown',AI_DROPDOWN_ICON],
  ['ai-checkbox',AI_CHECKBOX_ICON],
  ['ai-suggested-fields',AI_SUGGESTED_FIELD_ICON],
  ['ai-hashtag',AI_HASHTAG_ICON],
  ['doc-warning', DOC_WARNING],
  ['campaign-contact', CAMPAIGN_CONTACT],
  ['delete-contact', DELETE_CONTACT],
  ['payment-icon', PAYMENT_ICON],
  ['see-my-legacy',SEEMYLEGACY_ICON],
  ['approve-applicant',APPROVE_APPLICANT],
  ['reject-applicant',REJECT_APPLICANT],
  ['reopen-item',REOPEN_ITEM],
  ['awaiting-review', AWAITING_REVIEW],
  ['total-applicants',TOTAL_APPLICANTS],
  ['approved-applicants',APPROVED_APPLICANTS],
  ['send-email-icon', SEND_EMAIL_ICON],
  ['setup-ai',SETUP_AI_CAMPAIGN],
  ['setup-builder',SETUP_CAMPAIGN_BUILDER],
  ['setup-template',SETUP_CAMPAIGN_TEMPLATE],
  ['approve-confirmation-tick', APPROVE_CONFIRMATION_TICK],
  ['reject-applicant-dialog', REJECT_APPLICANT_DIALOG],
  ['application-required', APPLICATION_REQUIRED],
  ['no-application-required', NO_APPLICATION_REQUIRED],
  ['ai-registration-step-icon',AI_REGISTRATION_STEP_ICON],
  ['ai-sponsorship-step-icon',AI_SPONSORSHIP_STEP_ICON],
  ['ai-memorial-step-icon',AI_MEMORIAL_STEP_ICON],
  ['ai-volunteer-step-icon',AI_VOLUNTEER_STEP_ICON],
  ['ai-fundraiser-step-icon',AI_FUNDRAISER_STEP_ICON],
  ['ai-ticketing-step-icon',AI_TICKETING_STEP_ICON],
  ['ai-step-4-icon',AI_STEP_4_ICON],
  ['campaign-option-team',CAMPAIGN_OPTION_TEAM],
  ['campaign-option-builder',CAMPAIGN_OPTION_BUILDER],
  ['campaign-option-template',CAMPAIGN_OPTION_TEMPLATE],
  ['campaign-option-clock',CAMPAIGN_OPTION_CLOCK],
  ['campaign-option-bolt',CAMPAIGN_OPTION_BOLT],
  ['small-tick',SMALL_TICK],
  ['circle-percentage',CIRCLE_PERCENTAGE],
  ['small-ticket',SMALL_TICKET],
  ['help-circle', HELP_CIRCLE],
  ['calendar-line', CALENDAR_LINE],
  ['chat-bubble', CHAT_BUBBLE],
  ['chevron-forward', CHEVRON_FORWARD],
  ['mail-line', MAIL_LINE],
  ['phone-line', PHONE_LINE],
  ['payments', PAYMENTS],
  ['sort-arrow-down', SORT_ARROW_DOWN],
  ['disbursement-update-badge', DISBURSEMENT_UPDATE_BADGE],
  ['disbursement-success-badge', DISBURSEMENT_SUCCESS_BADGE],
  ['disbursement-expand', DISBURSEMENT_EXPAND],
  // Campaign Overview v2 (libs/features/campaign/campaign-overview-v2)
  ['co-arrow-up', CO_ARROW_UP],
  ['co-medal', CO_MEDAL],
  ['co-spark-orange', CO_SPARK_ORANGE],
  ['co-spark-pink', CO_SPARK_PINK],
  ['co-badge-check', CO_BADGE_CHECK],
  ['co-pin-filled', CO_PIN_FILLED],
  ['co-pin-outline-thick', CO_PIN_OUTLINE_THICK],
  ['co-pin-outline', CO_PIN_OUTLINE],
  ['co-chevron-down-thick', CO_CHEVRON_DOWN_THICK],
  ['co-chevron-down', CO_CHEVRON_DOWN],
  ['co-outlink', CO_OUTLINK],
  ['co-calendar', CO_CALENDAR],
  ['co-plus', CO_PLUS],
  ['co-user-plus', CO_USER_PLUS],
  ['co-dedication', CO_DEDICATION],
  ['co-map-art-grid', CO_MAP_ART_GRID],
  ['co-check', CO_CHECK],
  ['co-map-art-river', CO_MAP_ART_RIVER],
  ['co-folded-map', CO_FOLDED_MAP],
  ['co-folded-map-small', CO_FOLDED_MAP_SMALL],
  ['co-back-arrow', CO_BACK_ARROW],
  ['co-dot', CO_DOT],
  ['co-toggle', CO_TOGGLE],
  ['co-activity-log', CO_ACTIVITY_LOG],
  ['co-duplicate', CO_DUPLICATE],
  ['co-move', CO_MOVE],
  ['co-link', CO_LINK],
  ['co-address-map', CO_ADDRESS_MAP],
  ['co-arrow-out', CO_ARROW_OUT],
  ['co-close', CO_CLOSE],
  ['co-search', CO_SEARCH],
  ['co-eye', CO_EYE],
  ['co-chevron-right', CO_CHEVRON_RIGHT],
  ['co-chevron-left', CO_CHEVRON_LEFT],
  ['co-expand', CO_EXPAND],
  ['co-zoom-out', CO_ZOOM_OUT],
  ['co-zoom-in', CO_ZOOM_IN],
  ['co-crosshair', CO_CROSSHAIR]
]);

export const ICONS = new InjectionToken('ICONS');